// Mirrors backend/pitch_deck.py calculate()
export const DEFAULT_RATES = { renewals: 80, reconciliation: 70, minutes: 50, newsletter: 60, website: 70, licences: 80, contractor: 70 };
export const HOUR_SHARES = { renewals: 0.25, reconciliation: 0.15, minutes: 0.2, newsletter: 0.15, website: 0.1 };
export const RATE_LABELS = {
  renewals: 'Renewal chasing & receipting', reconciliation: 'Bank reconciliation', minutes: 'Minutes & agenda preparation',
  newsletter: 'Newsletter / email list upkeep', website: 'Website updates', licences: 'Licence stack', contractor: 'Contractor spend',
};

export function calculate(inp, rates = {}) {
  const r = { ...DEFAULT_RATES, ...rates };
  const hours = Number(inp.hours_per_month) || 0;
  const tools = Number(inp.tool_spend) || 0;
  const contractor = Number(inp.contractor_spend) || 0;
  const running = Number(inp.running_cost) || 0;
  const hourValue = Number(inp.hour_value) || 0;
  const frac = Object.keys(HOUR_SHARES).reduce((s, k) => s + HOUR_SHARES[k] * (r[k] / 100), 0);
  const hoursSavedMonth = hours * frac;
  const moneySaved = tools * (r.licences / 100) + contractor * (r.contractor / 100) - running;
  return {
    hours_saved_month: Math.round(hoursSavedMonth * 10) / 10,
    hours_saved_year: Math.round(hoursSavedMonth * 12),
    hours_after_month: Math.round((hours - hoursSavedMonth) * 10) / 10,
    money_saved_year: Math.round(moneySaved),
    spend_after_year: Math.round(tools + contractor - moneySaved),
    hours_value_year: Math.round(hoursSavedMonth * 12 * hourValue),
    hour_fraction: Math.round(frac * 100),
  };
}

export const money = (v) => `$${Math.round(Number(v) || 0).toLocaleString()}`;
